/**
 * Editorial fullscreen navigation overlay — submenu panels + promo media.
 */
(function() {
  var overlay;
  var panels = [];
  var promoSlides = [];
  var triggers = [];
  var backButtons = [];
  var activePanelId = null;

  var classes = {
    submenuOpen: 'has-submenu-open',
    promoActive: 'has-promo-active',
    panelActive: 'is-active',
    itemCurrent: 'is-current',
    videoPlaying: 'is-video-playing'
  };

  function getOverlay() {
    return document.getElementById('HeaderNavOverlay');
  }

  function cacheElements() {
    overlay = getOverlay();
    if (!overlay) {
      return false;
    }

    panels = Array.prototype.slice.call(
      overlay.querySelectorAll('.header-nav-overlay__submenu-panel[data-submenu-panel]')
    );
    promoSlides = Array.prototype.slice.call(
      overlay.querySelectorAll('.header-nav-overlay__promo-panel[data-nav-key]')
    );
    triggers = Array.prototype.slice.call(
      overlay.querySelectorAll('.js-overlay-nav-trigger')
    );
    backButtons = Array.prototype.slice.call(
      overlay.querySelectorAll('.js-overlay-nav-back')
    );
    return true;
  }

  function setPanelHidden(panel, hidden) {
    if (hidden) {
      panel.setAttribute('hidden', '');
    } else {
      panel.removeAttribute('hidden');
    }
  }

  function pausePromoVideo(slide) {
    if (!slide) {
      return;
    }

    var video = slide.querySelector('.header-nav-overlay__promo-video');
    if (!video) {
      return;
    }

    video.pause();
    try {
      video.currentTime = 0;
    } catch (e) {
      /* ignore */
    }
    slide.classList.remove(classes.videoPlaying);
  }

  function playPromoVideo(slide) {
    var video = slide.querySelector('.header-nav-overlay__promo-video');
    if (!video) {
      return;
    }

    function attemptPlay() {
      var playPromise = video.play();

      if (playPromise && typeof playPromise.then === 'function') {
        playPromise
          .then(function() {
            slide.classList.add(classes.videoPlaying);
          })
          .catch(function() {
            slide.classList.remove(classes.videoPlaying);
          });
      }
    }

    if (video.readyState < 2) {
      video.load();
      video.addEventListener('loadeddata', attemptPlay, { once: true });
      return;
    }

    attemptPlay();
  }

  function clearPromo() {
    if (!overlay) {
      return;
    }

    overlay.classList.remove(classes.promoActive);

    promoSlides.forEach(function(slide) {
      slide.classList.remove(classes.panelActive);
      setPanelHidden(slide, true);
      pausePromoVideo(slide);
    });
  }

  function showPromo(navKey) {
    if (!overlay || !navKey) {
      return;
    }

    var nextSlide = overlay.querySelector(
      '.header-nav-overlay__promo-panel[data-nav-key="' + navKey + '"]'
    );

    if (!nextSlide) {
      return;
    }

    var previousSlide = null;
    promoSlides.forEach(function(slide) {
      if (slide.classList.contains(classes.panelActive)) {
        previousSlide = slide;
      }
    });

    if (previousSlide && previousSlide !== nextSlide) {
      previousSlide.classList.remove(classes.panelActive);
      setPanelHidden(previousSlide, true);
      pausePromoVideo(previousSlide);
    }

    promoSlides.forEach(function(slide) {
      if (slide !== nextSlide) {
        slide.classList.remove(classes.panelActive);
        setPanelHidden(slide, true);
        pausePromoVideo(slide);
      }
    });

    overlay.classList.add(classes.promoActive);
    setPanelHidden(nextSlide, false);

    window.requestAnimationFrame(function() {
      nextSlide.classList.add(classes.panelActive);

      window.requestAnimationFrame(function() {
        playPromoVideo(nextSlide);
      });
    });
  }

  function clearSubmenuState() {
    if (!overlay) {
      return;
    }

    activePanelId = null;
    overlay.classList.remove(classes.submenuOpen);
    clearPromo();

    panels.forEach(function(panel) {
      panel.classList.remove(classes.panelActive);
      setPanelHidden(panel, true);
    });

    triggers.forEach(function(trigger) {
      trigger.setAttribute('aria-expanded', 'false');
      var item = trigger.closest('.header-overlay-nav__item');
      if (item) {
        item.classList.remove(classes.itemCurrent);
      }
    });
  }

  function openSubmenu(panelId, trigger) {
    if (!overlay || panelId === activePanelId) {
      return;
    }

    var nextPanel = overlay.querySelector(
      '.header-nav-overlay__submenu-panel[data-submenu-panel="' + panelId + '"]'
    );
    if (!nextPanel) {
      return;
    }

    var previousPanel = activePanelId
      ? overlay.querySelector(
          '.header-nav-overlay__submenu-panel[data-submenu-panel="' + activePanelId + '"]'
        )
      : null;

    if (previousPanel && previousPanel !== nextPanel) {
      previousPanel.classList.remove(classes.panelActive);
      setPanelHidden(previousPanel, true);
    }

    triggers.forEach(function(btn) {
      btn.setAttribute('aria-expanded', 'false');
      var item = btn.closest('.header-overlay-nav__item');
      if (item) {
        item.classList.remove(classes.itemCurrent);
      }
    });

    panels.forEach(function(panel) {
      if (panel !== nextPanel) {
        panel.classList.remove(classes.panelActive);
        setPanelHidden(panel, true);
      }
    });

    activePanelId = panelId;
    overlay.classList.add(classes.submenuOpen);
    setPanelHidden(nextPanel, false);

    var navKey = trigger ? trigger.getAttribute('data-nav-key') : null;
    if (navKey) {
      showPromo(navKey);
    }

    window.requestAnimationFrame(function() {
      nextPanel.classList.add(classes.panelActive);
    });

    if (trigger) {
      trigger.setAttribute('aria-expanded', 'true');
      var currentItem = trigger.closest('.header-overlay-nav__item');
      if (currentItem) {
        currentItem.classList.add(classes.itemCurrent);
      }
    }
  }

  function onTriggerClick(evt) {
    evt.preventDefault();
    var trigger = evt.currentTarget;
    var panelId = trigger.getAttribute('data-submenu-panel');
    if (!panelId) {
      return;
    }
    openSubmenu(panelId, trigger);
  }

  function onBackClick(evt) {
    evt.preventDefault();
    clearSubmenuState();
  }

  function onCloseClick(evt) {
    evt.preventDefault();
    if (window.theme && window.theme.headerBurgerMenu && window.theme.headerBurgerMenu.close) {
      window.theme.headerBurgerMenu.close();
    }
  }

  function onKeyup(evt) {
    if (evt.key !== 'Escape') {
      return;
    }

    if (!overlay || !overlay.classList.contains('is-open')) {
      return;
    }

    if (activePanelId) {
      clearSubmenuState();
      return;
    }

    onCloseClick(evt);
  }

  function bindPromoVideos() {
    promoSlides.forEach(function(slide) {
      var video = slide.querySelector('.header-nav-overlay__promo-video');
      if (!video || video.dataset.boundPromo === 'true') {
        return;
      }

      video.dataset.boundPromo = 'true';
      video.addEventListener('playing', function() {
        slide.classList.add(classes.videoPlaying);
      });
      video.addEventListener('error', function() {
        slide.classList.remove(classes.videoPlaying);
      });
    });
  }

  function bindEvents() {
    triggers.forEach(function(trigger) {
      trigger.addEventListener('click', onTriggerClick);
    });

    backButtons.forEach(function(button) {
      button.addEventListener('click', onBackClick);
    });

    var closeButtons = overlay.querySelectorAll('.js-header-nav-overlay-close');
    closeButtons.forEach(function(button) {
      button.addEventListener('click', onCloseClick);
    });

    document.addEventListener('keyup', onKeyup);
  }

  function unbindEvents() {
    triggers.forEach(function(trigger) {
      trigger.removeEventListener('click', onTriggerClick);
    });

    backButtons.forEach(function(button) {
      button.removeEventListener('click', onBackClick);
    });

    if (overlay) {
      var closeButtons = overlay.querySelectorAll('.js-header-nav-overlay-close');
      closeButtons.forEach(function(button) {
        button.removeEventListener('click', onCloseClick);
      });
    }

    document.removeEventListener('keyup', onKeyup);
  }

  function activateDefault() {
    if (!cacheElements()) {
      return;
    }

    if (!triggers.length) {
      return;
    }

    var firstTrigger = triggers[0];
    var panelId = firstTrigger.getAttribute('data-submenu-panel');

    if (!panelId) {
      return;
    }

    openSubmenu(panelId, firstTrigger);
  }

  function init() {
    if (!cacheElements()) {
      return;
    }

    unbindEvents();
    clearSubmenuState();
    bindPromoVideos();
    bindEvents();
  }

  function reset() {
    clearSubmenuState();
  }

  window.theme = window.theme || {};
  window.theme.HeaderNavOverlay = {
    init: init,
    reset: reset,
    activateDefault: activateDefault
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
